import { GATSBY_ANT_MAN_URL, GATSBY_ENV } from './env';

const infcon2023CoursePage = GATSBY_ENV === 'production' ? 'https://www.inflearn.com/course/%EC%9D%B8%ED%94%84%EC%BD%98-2023' : 'https://www.devinflearn.com/course/temp_325584';

const prefix = GATSBY_ENV === 'localhost' ? '' : '/conf';

export const INFCON_PATH = `${prefix}/infcon-2023`;

export const URLS = {
  INFCON_2023__HOME: `${prefix}/infcon-2023/`,
  INFCON_2023__ACTION: `${GATSBY_ANT_MAN_URL}/pages/infcon-coc`,
  INFCON_2023__SESSION: `${prefix}/infcon-2023/session/`,
  INFCON_2023__SESSION_DETAIL: (id: string | number) => `${prefix}/infcon-2023/session-detail?id=${id}`,
  INFCON_2023__SESSION_DETAIL_SHARE: (id: string | number) => `/infcon-2023/schedule/session-detail?id=${id}${(GATSBY_ENV === 'production') ? '' : '&env=dev'}`,
  INFCON_2023__EVENT: `${prefix}/infcon-2023/info/event/`,
  INFCON_2023__STORY: `${prefix}/infcon-2023/info/story/`,
  INFCON_2023__FAQ: `${prefix}/infcon-2023/faq/`,
  INFCON_2023__MY: `${prefix}/infcon-2023/mypage/`,
  INFCON_2023__MY_NAVIGATE: '/infcon-2023/mypage/',
  INFCON_2023_EVENT_DETAIL: (slug: string) => `${GATSBY_ANT_MAN_URL}/pages/${slug}`,
  SIGNIN: `${GATSBY_ANT_MAN_URL}/user/signin`,
  INFCON_2023_COURSE_PAGE: infcon2023CoursePage,
  INFCON_2023_SHARE: (id: number, hash: string, name: string) => `${prefix}/infcon-2023/share?id=${id}&hash=${hash}&name=${name}`,
  INFCON_2023_REPLAY: 'https://www.inflearn.com/course/%EC%9D%B8%ED%94%84%EC%BD%982023-%EB%8B%A4%EC%8B%9C%EB%B3%B4%EA%B8%B0'
} as const;

export const API_URLS = {
  EVENT_LIST: '/api/infcon/pages?subType=EVENT',
  STORY_LIST: '/api/infcon/pages?subType=STORY',
  SESSION_LIST: '/api/infcon/pages?subType=SESSION',
  PROGRAM_LIST: '/api/infcon/pages?subType=PARTICIPATION',
  USER_SESSION: '/api/v1/session?version=2',
  SPEAKER_SESSION_DETAIL: (id: number) => `/api/infcon/pages/${id}`,
  ADD_SCHEDULE: (id: number) => `/api/infcon/pages/${id}/schedule`,
  DELETE_SCHEDULE: (id: number) => `/api/infcon/pages/${id}/schedule`,
  MY_SCHEDULE: '/api/infcon/my-schedule',
  SHARE_MY_SCHEDULE: '/api/infcon/my-schedule/link',
  USER_SCHEDULE: (userId: number, hash: string) => `/api/infcon/users/${userId}/${hash}/schedule`
};
